import { useEffect } from "react";
import { updateUserAccount } from "./Redux/Auth/operations";
import { useAppDispatch } from "./Redux/store";
import useAuth from "./Redux/useAuth";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./Layout";
import { WelcomePage } from "./PublicPages/WelcomePage/WelcomePage";
import RestrictedRoute from "./RestrictedRoute";
import { SignInPage } from "./PublicPages/SignInPage/SignInPage";
import { SignUpPage } from "./PublicPages/SignUpPage/SignUpPage";
import PrivateRoute from "./PrivateRoute";
import { HomePage } from "./PrivatePages/HomePage/HomePage";
import { NotFoundPage } from "./Components/NotFoundPage/NotFoundPage";
import { MainInfoPage } from "./PrivatePages/MainInfo/MainInfoPage";
import { LanguagesPage } from "./PrivatePages/Components/LanguagesPage/Languages";
import { SecurityPage } from "./PrivatePages/Components/SecurityPage/SecurityPage";
// import { ModesPage } from "./PrivatePages/Components/Modes/ModesPage";
import { LocalDataPage } from "./PrivatePages/Components/LocalDataPage/LocalData";
import { ContantUsPage } from "./PrivatePages/Components/ContactUs/ContactUs";
import { GlobalStylesApp } from "./GlobalStyles/GlobalStyles.styled";
import { useTokenExpiration } from "./Hooks/useTokenExpiration";
import { ConfirmEmailUser } from "./UpdateDatasUser/ConfirmEmail/ConfirmEmail";
import { PolicyPrivacyPage } from "./PublicPages/PolicyPrivacyPage/PolicyPrivacyPage";
import { ResetPassword } from "./UpdateDatasUser/ResetPassword/ResetPassword";
import { DeleteAccountSteps } from "./PublicPages/DeleteAccountSteps/DeleteAccountSteps";
import { CreditPage } from "./PrivatePages/Components/CreditPage/CreditsPage";

export const App = () => {
  const { user, isRefreshing } = useAuth();
  const dispatch = useAppDispatch();

  useTokenExpiration();
  useEffect(() => {
    dispatch(updateUserAccount());
  }, [dispatch]);

  if (isRefreshing) return <b>Refreshing user...</b>;

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<WelcomePage />} />
          <Route path="/policy-privacy" element={<PolicyPrivacyPage />} />
          <Route path="/delete-account" element={<DeleteAccountSteps />} />
          <Route
            path="/reset-password-user/:token"
            element={<ResetPassword />}
          />
          <Route
            path="/confirm-email/:verificationToken"
            element={<ConfirmEmailUser />}
          />
          <Route
            path="/sign-up"
            element={
              <RestrictedRoute
                redirectTo={
                  user?.name
                    ? `/home-page/${user?.name?.toLowerCase()}`
                    : "/home-page/:nameuser"
                }
                component={<SignUpPage />}
              />
            }
          />
          <Route
            path="/sign-in"
            element={
              <RestrictedRoute
                redirectTo={
                  user?.name
                    ? `/home-page/${user?.name?.toLowerCase()}`
                    : "/home-page/:nameuser"
                }
                component={<SignInPage />}
              />
            }
          />

          <Route
            path="home-page/:nameuser"
            element={
              <PrivateRoute redirectTo="/sign-in" component={<HomePage />} />
            }
          />
          <Route
            path="/home-page/:nameuser/main-info"
            element={
              <PrivateRoute
                redirectTo="/sign-in"
                component={<MainInfoPage />}
              />
            }
          />
          <Route
            path="/home-page/:nameuser/security-page"
            element={
              <PrivateRoute
                redirectTo="/sign-in"
                component={<SecurityPage />}
              />
            }
          />
          <Route
            path="/home-page/:nameuser/languages"
            element={
              <PrivateRoute
                redirectTo="/sign-in"
                component={<LanguagesPage />}
              />
            }
          />
          {/* <Route
              path="/home-page/:nameuser/modes"
              element={
                <PrivateRoute redirectTo="/sign-in"
                  component={
                    <ModesPage
                      currentTheme={toggleTheme}
                    />
                  } />
              }
            /> */}
          <Route
            path="/home-page/:nameuser/local-data"
            element={
              <PrivateRoute
                redirectTo="/sign-in"
                component={<LocalDataPage />}
              />
            }
          />
          <Route
            path="/home-page/:nameuser/contacts"
            element={
              <PrivateRoute
                redirectTo="/sign-in"
                component={<ContantUsPage />}
              />
            }
          />
          <Route
            path="/home-page/:nameuser/credits"
            element={
              <PrivateRoute redirectTo="/sign-in" component={<CreditPage />} />
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <GlobalStylesApp />
    </>
  );
};
